import {
  exportExcel,
} from '@/api/rmfreevehicleserv'

export default {
  state: {
    state_RmFreeVehicle_ExportExcelResult: null,
  },
  mutations: {
    SET_RMFREEVEHICLE_EXPORTEXCEL_RESULT: (state, rst) => {
      state.state_RmFreeVehicle_ExportExcelResult = rst;
    },
  },
  actions: {
    RmFreeVehicleServ_ExportExcel({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        exportExcel(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_RMFREEVEHICLE_EXPORTEXCEL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_RMFREEVEHICLE_EXPORTEXCEL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
  },
  getters:{
    get_RmFreeVehicle_ExportExcelResult: state => {
      return state.state_RmFreeVehicle_ExportExcelResult;
    },
  }
}